<template>
    <div class="popup">
        <div ref="div" class="popup-item"></div>
        <svg class="popup__line-svg"/>
    </div>
</template>

<script>
    import { mapState } from 'vuex';

    import { 
        select as d3Select,
        selectAll as d3SelectAll,
        scaleLinear as d3ScaleLinear,
    } from 'd3';

import { setTimeout } from 'timers';

    export default {
        name: 'Popup',
        data() {
            return {
                radius: 600,
                newX: 0,
                newY: 0,
                line: '',
                planet: '',
                distToLeft: null,
                distToTop: null,
                itemPos: { x: 927, y: 0, z: 0 },
                course: null,
                year: null,
                popupContainer: '',
                popupItem: null,
                time: null,
                showPopup: true,
                title: '',
                pos: null,
                text: '',
                xScale: null,
                margin: {
                    left: 40,
                    right: 40,
                    top: 100,
                    bottom: 100,
                },
                clientWidth: null,
                visWidth: null,
                clientHeight: null
            }
        },
        props: ['snippetCurrent'],
        computed: {
            ...mapState(['sidebarVisible', 'visRendered', 'popupPos', 'yearsExtend', 'scrolling']),
        },
        watch: {
            sidebarVisible() {
                this.sideBarIsVisible();
            },
            popupPos() {
                this.updatePosition();
            },
            scrolling() {
                this.fetchPositions();
            }
        },
        methods: {
            dispatchPopupPos(state) {
                this.$store.dispatch("SET_POPUP_POS", state);
            },
            dispatchNodesAvailable(state) {
                this.$store.dispatch("SET_NODES_AVAILABLE", state);
			},
            sideBarIsVisible() {
                
            },
            setupPopup() {
                this.clientWidth = d3Select('#app').node().getBoundingClientRect().width;
                this.visWidth = d3Select('#app').node().getBoundingClientRect().width - d3Select('.sidebar-wrapper').node().getBoundingClientRect().width;
                this.clientHeight = d3Select('#app').node().getBoundingClientRect().height;

                this.popupContainer = d3Select(this.$refs.div);

                this.width = (this.visWidth) - this.margin.left - this.margin.right;

                this.popupContainer
                    .style('top', this.newY)
                    .style('left', this.newX)

                this.xScale = d3ScaleLinear()
                    .domain(this.yearsExtend)
                    .rangeRound([0, this.width]);

                this.setupPopupLine()
            },
            setupPopupLine() {
                let svg = d3Select('.popup__line-svg')
                    .attr('width',this.radius * 2)
                    .attr('height', this.radius * 2)
                    .style('stroke', '2px')

                this.line = svg.append('line')
                    .classed('popup__line', true)

                let orbitPath = d3Select('.popup__line-svg').append('circle')
                    .attr('r' , this.radius)
                    .attr('cx', this.radius)
                    .attr('cy', this.radius)
                    .attr('fill', 'none')

                this.planet = svg.append('circle')
                    .attr('r', 3)
                    .attr('cx' , 10)
                    .attr('cy' , 10);

                this.popupItem = d3Select('.popup-item');                

                let center = svg.append('circle')
                    .attr('r', 3)
                    .attr('cx', this.radius)
                    .attr('cy', this.radius)
                    .classed('anchor', true);

                // // only for debugging
                // var borderPath = svg.append("rect")
                //     .attr("x", 0)
                //     .attr("y", 0)
                //     .attr("height", this.radius * 2)
                //     .attr("width", this.radius * 2)
                //     .style("stroke", 'black')
                //     .style("fill", "none")
                //     .style("stroke-width", '2px');


                this.setupContent();

            },
            updatePosition() {

                if (this.course != null && this.year != null && this.popupPos != undefined) {
                    
                    this.dispatchNodesAvailable(true);

                    let relPosX = (this.popupPos[0] + this.radius) / this.clientWidth;
                    let relPosY = (this.popupPos[1] + this.radius) / this.clientHeight;
    
                    let x = (1 - relPosX) * this.clientWidth;
                    let y = (1 - relPosY) * this.clientHeight;
    
                    let dx = x - (this.clientWidth / 2);
                    let dy = y - (this.clientHeight / 2);
    
                    let dist = Math.sqrt(dx*dx + dy*dy);
    
                    this.newX = this.radius + dx * .3 * this.radius / dist;
                    this.newY = this.radius + dy * .8 * this.radius / dist;
    
                    this.planet
                        .attr('cx',this.newX)
                        .attr('cy',this.newY);

                    d3Select('.popup')
                        .style('left', `${this.popupPos[0]}px`)
                        .style('top', `${this.popupPos[1]}px`)
                        .classed('active', this.showPopup)
    
                    this.line
                        .attr('x1', this.radius)
                        .attr('y1', this.radius)
                        .attr('x2', this.newX)
                        .attr('y2', this.newY)
    
                    this.popupContainer
                        .style('top', `${this.newY}px`)
                        .style('left', `${this.newX}px`)
                }

            },
            fetchPositions() {
                this.clientWidth = d3Select('#app').node().getBoundingClientRect().width;
                this.visWidth = d3Select('#app').node().getBoundingClientRect().width - d3Select('.sidebar-wrapper').node().getBoundingClientRect().width;
                this.clientHeight = d3Select('#app').node().getBoundingClientRect().height;

                this.course = null;
                this.year = null;
                let nodeCourse = d3Select(`rect#id-${this.snippetCurrent.pos[0]}`);

                this.width = (this.visWidth) - this.margin.left - this.margin.right;

                this.xScale = d3ScaleLinear()
                    .domain(this.yearsExtend)
                    .rangeRound([0, this.width]);    
                
                this.xScale.domain(this.yearsExtend);

                // console.log(this.width);

                
                if (nodeCourse.node() != null) {
                    this.course = nodeCourse.node().getBoundingClientRect();

                    this.year = this.xScale(this.snippetCurrent.pos[1]); // position inside svg

                    this.distToTop = parseFloat(this.course.top) - this.radius;
                    this.distToLeft = this.year - this.radius - this.margin.left - 380; // check different radius für screen widths ...

                    this.dispatchPopupPos([this.distToLeft, this.distToTop])

                    // console.log([this.distToLeft, this.distToTop], this.course.top);

                    this.updatePosition();
                }
            },
            setupContent() {
                if (this.snippetCurrent.title.length > 0) {
                    this.title = this.popupContainer.append('h2').classed('popup-title', true);
                    this.title.text(`${this.snippetCurrent.title}`);

                    this.fetchPositions()
                }

                if (this.snippetCurrent.text.length > 0) {
                    this.text = this.popupContainer.append('p').classed('popup-text', true);
                    this.text.text(`${this.snippetCurrent.text}`);

                    this.fetchPositions()
                }
            },
            updateContent() {
                if (this.snippetCurrent.title.length > 0) {
                    this.title.text(`${this.snippetCurrent.title}`);
                }

                if (this.snippetCurrent.text.length > 0) {
                    this.text.text(`${this.snippetCurrent.text}`);
                }
            },
        },
        mounted() {
            setTimeout(() => {  
                this.setupPopup();
            }, 500)

            setTimeout(() => { d3Select('.popup').attr('class', `popup active ${this.sidebarVisible}`); }, 1000)            

            window.addEventListener('resize', () => {
                
            });
        }
    }
</script>

<style lang="scss">
    @import '../assets/style/main.scss';

    .popup {
        z-index: 12;
        position: fixed;
        top: 0;
        right: 0;
        pointer-events: none;
        opacity: 0;
        color: $color-primary;
        transform: translateX($sidebar-width);
        // transition: opacity $time-s ease-in-out;

        &.behind {
            opacity: 0 !important;
        }

        &.active {
            opacity: 1;
            transition: opacity $time-s ease-in-out;
        }

        &-text {
            line-height: 150%;
            font-size: $font-size-m;
            margin-block-end: 0;
        }

        &-item {
            background: $color-white;
            border-radius: 4px;
            position: absolute;
            width: 300px;
            height: auto;
            opacity: .9;
            padding: 15px;
            transform: translate(-50%, -50%);
            display: flex;
            flex-direction: column;
        }

        &__line {
            stroke: $color-primary;
            stroke-width: 1;
            stroke-dasharray: 3,3;
        }

        circle.anchor {
            fill: $color-primary;
        }

        .popup-title {
            margin-top: 5px;
            font-weight: 600;
            margin-bottom: 5px;
            width: 270px;
            font-size: $font-size-m !important;
            line-height: $line-height-m;
            font-size: $font-size-ml;
        }

        .popup-text {
            line-height: 150%;
            margin-top: 0;
            font-size: $font-size-m !important;
            margin-block-end: 0;
        }

        .popup-subtitle {
            margin-top: 0;
            font-weight: 600;
            line-height: $line-height-m;
            font-size: $font-size-s;
            text-transform: uppercase;
            letter-spacing: $letter-spacing-l;
            opacity: 0.5;
        }

        .popup-sequence {
            font-size: $font-size-m;
            margin-bottom: 15px;
        }

        .popup-description {
            margin-top: 0px;
            font-size: $font-size-m;
            margin-bottom: 15px;
            color: $color-primary-50;
        }


    }
</style>


